<ngx-loading
      [show]="isLoading"
      [config]="{
        backdropBorderRadius: '3px',
        fullScreenBackdrop: true
      }"></ngx-loading>